module.exports = __webpack_public_path__ + "static/media/coming-soon.782ad99f.png";